import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { deleteNotification as deleteNotificationRequest } from "../api/notification.api";
import { useResultHandler } from "../../../hooks/useResultHandler";

export const useDeleteNotification = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { handleResult } = useResultHandler();

  const deleteNotification = useCallback(
    async (id: string) => {
      try {
        setLoading(true);
        setError(null);
        const response = await deleteNotificationRequest(id);
        const isSuccess = handleResult(response, {
          successMessage: t("notification.notification_deleted_successfully"),
        });
        if (!isSuccess) {
          throw new Error(
            response.user_message || response.message || "Failed to delete notification",
          );
        }

        return response;
      } catch (deleteError) {
        const message =
          deleteError instanceof Error ? deleteError.message : "Failed to delete notification";
        setError(message);
        throw deleteError;
      } finally {
        setLoading(false);
      }
    },
    [handleResult, t],
  );

  return { deleteNotification, loading, error };
};
